import { getAppConfig } from '../config/appConfigRef';

export function isPublicPath(pathname: string): boolean {
  const { publicPathPrefix, loginCallbackPath, extraPublicPaths } = getAppConfig();
  if (pathname.startsWith(publicPathPrefix)) return true;
  if (pathname === loginCallbackPath || pathname.startsWith(`${loginCallbackPath}/`)) {
    return true;
  }
  return extraPublicPaths?.some((p) => pathname === p || pathname.startsWith(`${p}/`)) ?? false;
}
